import { r as c, c as f } from "../lit-element-8JrrHldg.js";
import { p as m } from "../pwcProperty-CTLG9yrF.js";
import { c as g } from "../clsx-DB4S2d7J.js";
import { n as u } from "../property-4FoNj0Pi.js";
import { u as v } from "../static-CPcCYSrK.js";
var d = Object.defineProperty, y = Object.getOwnPropertyDescriptor, l = (t, e, s, o) => {
  for (var r = o > 1 ? void 0 : o ? y(e, s) : e, p = t.length - 1, n; p >= 0; p--)
    (n = t[p]) && (r = (o ? n(e, s, r) : n(r)) || r);
  return o && r && d(e, s, r), r;
};
const a = {
  size: "64px"
};
let i = class extends c {
  createRenderRoot() {
    return this;
  }
  render() {
    const { logomark: t, size: e = a.size, inline: s } = this;
    let o = e && e != null && !isNaN(+e) ? `${e}px` : e;
    return `${o}`.length || (o = a.size), v`<div
      class=${g("PwcLogomark", { "PwcLogomark--inline": s })}
      style="--size:${o};"
    >
      <img
        src="https://cdn.ecoonline.com/assets/logos/logomarks/${t}.svg"
        alt="logomark ${t}"
      />
    </div>`;
  }
};
l([
  u({
    type: String,
    reflect: !0
  })
], i.prototype, "logomark", 2);
l([
  m({ type: Boolean, default: !1 })
], i.prototype, "inline", 2);
l([
  m({ type: String, default: a.size })
], i.prototype, "size", 2);
i = l([
  f("pwc-logomark")
], i);
export {
  i as PwcLogomark
};
